// Copyright © 2025 The Things Industries B.V.

import { getContrastingTextColor } from '@console/components/pill/utils.tti'

const selectStyles = {
  menuList: base => ({
    ...base,
    padding: 0,
  }),
  menu: base => ({
    ...base,
    padding: '10px',
  }),
  multiValueGeneric: base => ({
    ...base,
    paddingLeft: '2px',
  }),
  multiValue: (base, { data }) => ({
    ...base,
    borderRadius: '3rem',
    padding: '7px',
    lineHeight: '1',
    fontSize: '10.5px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: data._meta?.color,
    border: getContrastingTextColor(data._meta?.color).withBorder
      ? '1px solid var(--c-border-neutral-normal)'
      : 'unset',
  }),
  multiValueLabel: (base, { data }) => ({
    ...base,
    padding: 0,
    fontWeight: '600',
    fontSize: '10.5px',
    color: getContrastingTextColor(data._meta?.color).textColor,
  }),
  multiValueRemove: (base, { data }) => ({
    ...base,
    paddingRight: '0px',
    color: getContrastingTextColor(data._meta?.color).textColor,
    ':hover': {
      cursor: 'pointer',
      backgroundColor: 'transparent',
      color: getContrastingTextColor(data._meta?.color).textColor,
    },
  }),
}

export default selectStyles
